import Vue from 'vue'
import VueRouter from 'vue-router'
import Download from "../views/Download"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Download',
    component: Download,
    props: {
      downloadId:'unknown'
    }
  },
  {
    path: '/:downloadId',
    name: 'Download',
    component: Download,
    props: true
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
